export function isNotEmpty(obj: any): boolean {
  if (!obj || typeof obj !== "object") {
    return false;
  }
  return Object.values(obj).some(
    (value) => value !== null && value !== undefined
  );
}

export function hasNestedEmptyValues(obj: any): boolean {
  if (!obj || typeof obj !== "object") {
    return false;
  }

  return Object.values(obj).some((value) => {
    if (value == null || value === "") {
      // Check for empty, null, or undefined values
      return true;
    }
    if (typeof value === "object") {
      // Recursively check nested objects
      return hasNestedEmptyValues(value);
    }
    return false;
  });
}

export function isEmptyObject(object: any): boolean {
  return Object.keys(object).length === 0;
}
